import React from 'react';
import { Button } from 'react-bootstrap';
import { TableWrapper, SectionTitle } from '../styled-components';
import { IVendorPriorityGroup } from '../types';
import { VendorType } from '../enums';
import { getEntityTypeName } from '../helpers';

interface IVendorTypeTableProps {
    vendorTypeKey: string;
    groups: IVendorPriorityGroup[];
    vendorIds: number[];
    getVendorName: (vendorId: number, vendorType?: number) => string;
    findPriority: (group: IVendorPriorityGroup, vendorId: number) => any;
    onStartEdit: (group: IVendorPriorityGroup) => void;
    isLoading: boolean;
    showEditModal: boolean;
    isSaving: boolean;
}

const VendorTypeTable: React.FC<IVendorTypeTableProps> = ({
    vendorTypeKey,
    groups,
    vendorIds,
    getVendorName,
    findPriority,
    onStartEdit,
    isLoading,
    showEditModal,
    isSaving
}) => {
    const vendorType = groups[0]?.vendorType;

    const title = vendorType === VendorType.KIT ?
        'Kit Vendor Distribution' :
        'Phlebotomy Vendor Distribution';

    return (
        <div className="vendor-type-section">
            <SectionTitle>{title}</SectionTitle>

            <TableWrapper striped bordered hover>
                <thead>
                    <tr>
                        <th>Entity Type</th>
                        {vendorIds.map(vendorId => (
                            <th key={vendorId}>{getVendorName(vendorId, vendorType)}</th>
                        ))}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {groups.map(group => (
                        <tr key={`${group.vendorType}-${group.entityType}`}>
                            <td>{getEntityTypeName(group.entityType)}</td>

                            {vendorIds.map(vendorId => {
                                const priority = findPriority(group, vendorId);
                                const value = priority?.odds || 0;

                                return (
                                    <td key={`${group.vendorType}-${group.entityType}-${vendorId}`}>
                                        <span className={value === 0 ? "zero-value" : "odds-value"}>
                                            {value}%
                                        </span>
                                    </td>
                                );
                            })}

                            <td>
                                <Button
                                    bsStyle="primary"
                                    bsSize="xs"
                                    onClick={() => onStartEdit(group)}
                                    disabled={isLoading || showEditModal || isSaving}
                                >
                                    <span className="glyphicon glyphicon-pencil"></span> Edit
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </TableWrapper>
        </div>
    );
};

export default VendorTypeTable;